const buttonDoorInInterior = document.getElementById('buttonDoorInInterior')
const arrowIcon = document.querySelector('.Button__icon-svg-interior')

function overlapDoorInInterior() {
	const doorInInterior = document.getElementById('doorInInterior')

	if (doorInInterior.classList.contains('hideA')) {
		doorInInterior.classList.remove('hideA')
		doorInInterior.classList.add('showA')
		arrowIcon.style.transform = 'rotate(180deg)'
		setTimeout(() => {
			doorInInterior.style.opacity = '1'
		}, 500)
	} else {
		doorInInterior.classList.remove('showA')
		doorInInterior.classList.add('hideA')
		arrowIcon.style.transform = 'rotate(0deg)'
		arrowIcon.style.webkitTransform = 'rotate(0deg)'
		setTimeout(() => {
			doorInInterior.style.opacity = '0'
		}, 500)
	}
}
